import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationCityUpdatePutBody,
  IConfigurationCityUpdateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationCityUpdateAPI = () => {
  const [updatedCityId, setUpdatedCityId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (cityData: IConfigurationCityUpdatePutBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!cityData) {
          return;
        }
        await axios
          .put(`${CONFIGURATION_APIS?.CITY_UPDATE?.baseURL}`, cityData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationCityUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedCityId(res?.data?.data?.city_id);
              toast.success(`${cityData?.city_name} has been updated successfully.`);
            } else {
              // console.log("not created");
              toast.error("Cannot create city.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("City already exists");
            // toast.error("Error at server while updating city details.");
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
          // if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { updatedCityId, execute };
};
